var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 4H14C8.48 4 4 8.46 4 13.96V25.92V27.92C4 33.42 8.48 37.88 14 37.88H17C17.54 37.88 18.26 38.24 18.6 38.68L21.6 42.66C22.92 44.42 25.08 44.42 26.4 42.66L29.4 38.68C29.78 38.18 30.38 37.88 31 37.88H34C39.52 37.88 44 33.42 44 27.92V13.96C44 8.46 39.52 4 34 4ZM26 27.5H14C13.18 27.5 12.5 26.82 12.5 26C12.5 25.18 13.18 24.5 14 24.5H26C26.82 24.5 27.5 25.18 27.5 26C27.5 26.82 26.82 27.5 26 27.5ZM34 17.5H14C13.18 17.5 12.5 16.82 12.5 16C12.5 15.18 13.18 14.5 14 14.5H34C34.82 14.5 35.5 15.18 35.5 16C35.5 16.82 34.82 17.5 34 17.5Z",
    fill: "#0092A1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageText);
export default __webpack_public_path__ + "static/media/message_text.2bf6230069caa600040155f75809711a.svg";
export { ForwardRef as ReactComponent };